(function () {
  const SLIDER_SELECTOR =
    ".cbb-also-bought-container .cbb-also-bought-slider, .cbb-also-bought-slider-container .cbb-also-bought-slider";

  function getProductScrollPosition(product, slider) {
    const sliderRect = slider.getBoundingClientRect();
    const productRect = product.getBoundingClientRect();
    return productRect.left - sliderRect.left + slider.scrollLeft;
  }

  function snapToNearestProduct(slider) {
    const products = slider.querySelectorAll(".cbb-also-bought-product");
    if (!products.length) return;

    const scrollLeft = slider.scrollLeft;
    const maxScroll = Math.max(0, slider.scrollWidth - slider.clientWidth);
    let targetScroll = 0;
    let minDistance = Infinity;

    products.forEach((product) => {
      const position = Math.min(getProductScrollPosition(product, slider), maxScroll);
      const distance = Math.abs(scrollLeft - position);

      if (distance < minDistance) {
        minDistance = distance;
        targetScroll = position;
      }
    });

    slider.style.scrollSnapType = "none";
    slider.scrollTo({ left: targetScroll, behavior: "smooth" });

    window.setTimeout(() => {
      slider.style.removeProperty("scroll-snap-type");
    }, 350);
  }

  function applyMomentum(slider, velocity, onComplete) {
    let speed = velocity * 16;

    const step = () => {
      if (Math.abs(speed) < 0.5) {
        onComplete();
        return;
      }

      slider.scrollLeft -= speed;
      speed *= 0.92;
      requestAnimationFrame(step);
    };

    requestAnimationFrame(step);
  }

  function initDragScroll(slider) {
    if (slider.dataset.dragScrollInit === "true") return;
    if (slider.scrollWidth <= slider.clientWidth) return;

    slider.dataset.dragScrollInit = "true";

    let isDragging = false;
    let startX = 0;
    let scrollLeft = 0;
    let moved = false;
    let lastX = 0;
    let lastTime = 0;
    let velocity = 0;
    let startTarget = null;

    slider.addEventListener(
      "pointerdown",
      (event) => {
        if (event.pointerType === "touch") return;
        if (event.button !== 0) return;

        isDragging = true;
        moved = false;
        velocity = 0;
        startX = event.clientX;
        lastX = event.clientX;
        lastTime = performance.now();
        scrollLeft = slider.scrollLeft;
        slider.classList.add("is-dragging");
        slider.style.scrollSnapType = "none";
        slider.setPointerCapture(event.pointerId);
        startTarget = event.target;
      },
      { capture: true }
    );

    slider.addEventListener(
      "pointermove",
      (event) => {
        if (!isDragging) return;

        const now = performance.now();
        const delta = event.clientX - startX;
        const frameDelta = event.clientX - lastX;
        const elapsed = now - lastTime;

        if (Math.abs(delta) > 3) moved = true;
        if (!moved) return;

        if (elapsed > 0) {
          velocity = frameDelta / elapsed;
        }

        lastX = event.clientX;
        lastTime = now;
        event.preventDefault();
        slider.scrollLeft = scrollLeft - delta;
      },
      { passive: false }
    );

    const endDrag = (event) => {
      if (!isDragging) return;

      isDragging = false;
      slider.classList.remove("is-dragging");

      try {
        slider.releasePointerCapture(event.pointerId);
      } catch (error) {
        /* pointer may already be released */
      }

      if (!moved) {
        slider.style.removeProperty("scroll-snap-type");
        if (startTarget) {
          const link = startTarget.closest("a, [data-href]");
          if (link) {
            if (startTarget.closest(".sm-product-card__icon-btns") || startTarget.closest("button")) {
              // Handled by pointerdown on the button
            } else {
              const href = link.getAttribute("href") || link.getAttribute("data-href");
              if (href && href !== "#") {
                window.location.href = href;
              } else {
                link.click();
              }
            }
          }
        }
        return;
      }

      const finishDrag = () => snapToNearestProduct(slider);

      if (Math.abs(velocity) > 0.05) {
        applyMomentum(slider, velocity, finishDrag);
      } else {
        finishDrag();
      }
    };

    slider.addEventListener("pointerup", endDrag);
    slider.addEventListener("pointercancel", endDrag);

    slider.addEventListener(
      "click",
      (event) => {
        if (!moved) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        moved = false;
      },
      true
    );
  }

  function initAll() {
    document.querySelectorAll(SLIDER_SELECTOR).forEach(initDragScroll);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  const observer = new MutationObserver(
    window.debounce ? window.debounce(initAll, 200) : initAll
  );
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
